import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { resetReducerState } from "../action"
import { SearchSendingJobRequest } from "./../../models/massMailing"

export type massMailingsStateType = {
    searchSendingJobRequestParams: SearchSendingJobRequest | undefined
}

const initialState: massMailingsStateType = {
    searchSendingJobRequestParams: undefined
}

const massMailingSlice = createSlice({
    name: "massMailing",
    initialState,
    reducers: {
        setSearchSendingJobRequestParams(state, action: PayloadAction<SearchSendingJobRequest>) {
            state.searchSendingJobRequestParams = action.payload
        }
    },
    extraReducers(builder) {
        builder.addCase(resetReducerState, () => {
            return initialState
        })
    }
})

export const MassMailingReducer = massMailingSlice.reducer

export const massMailingActions = massMailingSlice.actions
